// login
export const SET_LOGIN_INFO  = "SET_LOGIN_INFO";

// user
export const SET_USER_TOKEN  = "SET_USER_TOKEN";
export const SET_USER_INFO   = "SET_USER_INFO";
export const SET_USER_RESET  = "SET_USER_RESET";


